/**
 * StepByStep
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import clsx from 'clsx';
var renderChildren = function (children, listType) {
    var renderedChildren = React.Children.map(children, function (child, index) {
        if (!child)
            return null;
        var props = child && child.props ? __assign({}, child.props) : {};
        if (!React.isValidElement(child)) {
            return child;
        }
        if (typeof child.type !== 'string') {
            props.listType = listType;
            props.lastChild = index + 1 === children.length;
        }
        return React.cloneElement(child, props);
    });
    return renderedChildren;
};
/** A components that displays headers and texts in a numbered step by step layout. */
var StepByStep = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.listType, listType = _b === void 0 ? 'numbers' : _b;
    return (React.createElement("div", { className: clsx(className, listType === 'numbers'
            ? "stepbystep stepbystep--numbers border-l-3 border-primary-theme"
            : 'border-primary-1'), "data-cid": "StepByStep" }, renderChildren(children, listType)));
};
export default StepByStep;
